var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 1.51 1.51",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.38 0.63c0,0.47 -0.59,0.86 -0.59,0.86 -0.02,0.02 -0.05,0.02 -0.07,0 -0.03,-0.02 -0.59,-0.4 -0.59,-0.86 0,-0.08 0.01,-0.17 0.05,-0.24 0.03,-0.08 0.07,-0.15 0.13,-0.2 0.06,-0.06 0.13,-0.11 0.2,-0.14l0.01 0c0.07,-0.03 0.15,-0.05 0.23,-0.05 0.09,0 0.17,0.02 0.24,0.05 0.08,0.03 0.15,0.08 0.2,0.14 0.06,0.05 0.11,0.12 0.14,0.2 0.03,0.07 0.05,0.16 0.05,0.24zm-0.63 0.73c0.12,-0.08 0.5,-0.39 0.5,-0.73 0,-0.07 -0.01,-0.13 -0.04,-0.19 -0.02,-0.06 -0.06,-0.12 -0.1,-0.17 -0.05,-0.04 -0.11,-0.08 -0.17,-0.1 -0.06,-0.03 -0.12,-0.04 -0.19,-0.04 -0.06,0 -0.13,0.01 -0.19,0.03l0 0.01c-0.06,0.02 -0.11,0.06 -0.16,0.1 -0.05,0.05 -0.08,0.11 -0.11,0.17 -0.02,0.06 -0.04,0.12 -0.04,0.19 0,0.34 0.38,0.65 0.5,0.73z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 0.75c0.04,0 0.07,-0.01 0.09,-0.03 0.02,-0.03 0.04,-0.06 0.04,-0.09 0,-0.04 -0.02,-0.07 -0.04,-0.09l0 0c-0.02,-0.02 -0.05,-0.04 -0.09,-0.04 -0.03,0 -0.06,0.02 -0.09,0.04 -0.02,0.02 -0.03,0.05 -0.03,0.09 0,0.03 0.01,0.06 0.03,0.09l0 0c0.03,0.02 0.06,0.03 0.09,0.03zm0.18 0.05c-0.05,0.05 -0.11,0.08 -0.18,0.08 -0.07,0 -0.13,-0.03 -0.17,-0.08l0 0c-0.05,-0.04 -0.08,-0.1 -0.08,-0.17 0,-0.07 0.03,-0.13 0.08,-0.18l0 0c0.04,-0.04 0.1,-0.07 0.17,-0.07 0.07,0 0.13,0.03 0.18,0.07l0 0c0.04,0.05 0.07,0.11 0.07,0.18 0,0.07 -0.03,0.13 -0.07,0.17l0 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.08069b5a606982b6c85984d6310ebb17.svg";
export { ForwardRef as ReactComponent };